import {Directive, ElementRef, Renderer2, HostListener, OnInit} from '@angular/core';
import {DecimalPipe} from '@angular/common';
import {CurrencyPipe} from '@angular/common';

@Directive({
  selector: '[appCurrencyFormatter]'
})
export class CurrencyFormatterDirective implements OnInit {

  // currencyChars = new RegExp('[.,$]', 'g'); // we're going to remove commas and dots
  currencyChars = new RegExp('[,$]', 'g'); // we're going to remove commas and dots

  constructor(
    public el: ElementRef,
    public renderer: Renderer2,
    private readonly currencyPipe: CurrencyPipe,
  ) {
    this.format(this.el.nativeElement.value);
  }

  OnInit() {
    this.format(this.el.nativeElement.value); // format any initial values
  }

  ngOnInit() {
    this.OnInit(); // format any initial values
  }

  @HostListener('focusout', ['$event.target.value']) onInput(e: string) {
    this.format(e);
  }

  @HostListener('valChange', ['$event.detail.amt']) onInput2(e: string) {
    this.format(e);
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    event.preventDefault();
    this.format(event.clipboardData.getData('text/plain'));
  }

  format(val: string) {
    // 2. check and format the number as currency
    let numberFormat: number = 0;
    if (val && val !== '') {
      numberFormat = Number(val.replace(this.currencyChars, ''));
      if (isNaN(numberFormat)) {
        numberFormat = 0;
      }
    }
    const usd = this.currencyPipe.transform(numberFormat, 'USD', 'symbol', '1.2-2');

    // 3. replace the input value with formatted number
    this.renderer.setProperty(this.el.nativeElement, 'value', usd);
  }
}
